import React, { useState } from "react";

import { useHistory } from "react-router";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import FlexiTable from "views/pages/manage/common/data-grid/FlexiTable";
import { Card } from "@material-ui/core";
import { CardBody } from "reactstrap";
import StudentListTableHeader from "./StudentListTableHeader";
import PrintIdCardBtn from "../printIDCard";
import {
  gridComponents,
  gridStyles,
  isValidPhotoKey,
} from "../printIdCardAndMapRfid/constant";
import { Tooltip } from "@mui/material";
import AButton from "../../../common/form-fields-mui/AButton";
import PhotoCellComponent from "../printIdCardAndMapRfid/printIdCard/PhotoCellComponent";

const StudentListDataTable = ({
  rowsData,
  rowCount,
  nextButtonHandler,
  currentPage,
  isListLoading,
  totalPage,
}) => {
  const history = useHistory();
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const onPageSizeChange = (count) => {
    nextButtonHandler(0, count);
  };

  const onPageChange = (currentPage, limit) => {
    nextButtonHandler(currentPage, limit);
  };

  const ListHeader = [
    new AGridColDef("studentName", "Name")
      .setWidth(200)
      .renderCellComponent((params) => <span>{params.value}</span>),

    new AGridColDef("programAction", "Program")
      .setWidth(200)
      .renderCellComponent((params) => <span>{params.value}</span>),
    new AGridColDef("photoKey", "Photo", false)
      .setMinWidth(100)
      .setFlex(0.3)
      .renderCellComponent((params) => <PhotoCellComponent params={params} />),

    new AGridColDef("Actions", "Actions", false)
      .columnAlign("right")
      .renderCellComponent((params) => (
        <PrintIdCardBtn
          data={[
            {
              psid: params.row?.psid,
              applicationId: params?.row?.applicationId,
            },
          ]}
          rowData={[params?.row]}
          hideStepperBarPostPrint
          customTiggerButton
          customTriggerButtonComponent={() => (
            <AButton
              size="xs"
              variant="primary_filled"
              disabled={
                !params?.row?.isEligibleProgramActionForAllocation ||
                !isValidPhotoKey(params?.row?.photoKey)
              }
            >
              Preview and Print
            </AButton>
          )}
        />
      )),
  ];

  return (
    <Card className="h-100">
      <CardBody className="d-flex flex-column h-100">
        <StudentListTableHeader />
        <FlexiTable
          columns={[
            {
              field: "psid",
              headerName: "PSID",
              sortable: true,
              render: (row) => (
                <Tooltip title={row?.psid}>
                  <div
                    onClick={() =>
                      window.open(
                        history.createHref({
                          pathname: `/admin/edp/studentDetails/${row.psid}`,
                        }),
                        "_blank"
                      )
                    }
                    className={`ellipsis-text-container pointer color-primary`}
                  >
                    {row?.psid}
                  </div>
                </Tooltip>
              ),
            },
            {
              field: "applicationId",
              headerName: "Application No.",
              sortable: true,
              render: (row) => row.applicationId,
            },
            {
              field: "studentName",
              headerName: "Name",
              sortable: true,
              render: (row) => row.studentName,
            },
            {
              field: "programAction",
              headerName: "Program",
              sortable: true,
              render: (row) => row.programAction,
            },
            {
              field: "photoKey",
              headerName: "Photo",
              sortable: false,
              render: (row) => <PhotoCellComponent nextButtonHandler ={nextButtonHandler} params={row} />,
            },
            {
              field: "actions",
              headerName: "Actions",
              sortable: false,
              render: (row) => (
                <PrintIdCardBtn
                  data={[
                    {
                      psid: row?.psid,
                      applicationId: row?.applicationId,
                    },
                  ]}
                  rowData={[row]}
                  hideStepperBarPostPrint
                  customTiggerButton
                  customTriggerButtonComponent={() => (
                    <AButton
                      size="xs"
                      variant="primary_filled"
                      disabled={
                        !row?.isEligibleProgramActionForAllocation ||
                        !isValidPhotoKey(row?.photoKey)
                      }
                    >
                      Preview and Print
                    </AButton>
                  )}
                />
              ),
            },
          ]}
          rows={rowsData}
          totalRows={rowCount}
          page={currentPage}
          totalPage={totalPage}
          sortBy={"psid"}
          sortOrder={"asc"}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          onRowClick={(row) => console.log("Selected Row:", row)}
        />
      </CardBody>
    </Card>
  );
};

export default StudentListDataTable;
